import type { AppearanceVariant } from '../types';

import { ClassicPreview } from '../previews/classic';

export const classicVariant: AppearanceVariant = {
  id: 'classic',
  nameKey: 'appearance.classic',
  descriptionKey: 'appearance.classicDescription',
  className: 'erp-classic',
  composition: 'sidebar',
  groupedNavigation: false,
  documentEntry: 'continuous',
  Preview: ClassicPreview,
};
